import { Component, ComponentFactoryResolver, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConsoleService } from '@ng-select/ng-select/lib/console.service';
import { GovernorateService } from '../../../../../app/shared/API-Service/services/governorate.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { Image } from '../../../../../images/images'
import { BaseComponent } from 'src/app/shared/components/base/base.component';

@Component({
  selector: 'app-view-governorate',
  templateUrl: './view-governorate.component.html',
  styleUrls: ['./view-governorate.component.css']
})
export class ViewGovernorateComponent extends BaseComponent implements OnInit {
  governorate:object [] = [];
  img : string = Image;
  constructor(private _GovernorateService:GovernorateService,private _Router:Router) { 
    super()
  }

  ngOnInit(): void {
    this.getgovernorates();
  }
  pageChanged(event: any){
    this.pageNumber = event.page;// -1 * pageSize;
    this.pager.skipCount = (this.pageNumber - 1) * this.pager.maxResultCount;
   this.getgovernorates();
  }
  getgovernorates(){
    this._GovernorateService.GetGovernoratePaged(this.pager).subscribe((res) => {
      this.governorate = res.data.items
      this.totalCount=res.data.totalCount
    
    },(err)=>{
    },() =>{
    });
  }

  update(data){
    this._GovernorateService.Data.next(data);
    this._Router.navigate(['/content/admin/InsertGovernorate']);
    }

    delete(id : number){
      Swal.fire({
        title: 'هل تريد مسح العنصر ؟',
        text: "لن يكون لك صلاحية إعادته مره اخرى",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'الغاء',
        confirmButtonText: 'امسح العنصر !'
      }).then((result) => {
        if (result.isConfirmed) {
          this._GovernorateService.DeleteGovernorate(id).subscribe((res) => {
            Swal.fire({
              icon: "success",
              title: "تم المسح بنجاح",
              showConfirmButton: false,
              timer: 1500,
            });
         this.getgovernorates();
          },(err) => {
            Swal.fire({
              icon: 'error',
              title: 'خطأ',
              text:err.error.message    
            })
          },() => {
          })
        }
      }) 
    }
}
